import React, {Component} from 'react';
import ParkingSlotGraph from './../components/ParkingSlotGraph';

class ParkingSlotGraphContainer extends Component {

    constructor(props){
        super(props);
        this.state = {
            searchFieldsValues: {

            }
        }
    }


    fetchData = () => {
        const {
            handleFetchData
        } = this.props;

        handleFetchData({
            ...this.state.searchFieldsValues
        })
    }


    handleSearchFieldChange = (id, value) => {
        this.setState({
            searchFieldsValues: {
                ...this.state.searchFieldsValues,
                [id]: {
                    ...this.state.searchFieldsValues[id],
                    value: value
                }
            }
        })
    };


    handleSearchSubmit = () => {
        this.fetchData();
    }


    handleSearchClear = () => {
        this.setState({
            searchFieldsValues: Object.entries(this.state.searchFieldsValues)
                .reduce((acc, keyValuePair) => ({
                    ...acc,
                    [keyValuePair[0]]: {
                        ...keyValuePair[1],
                        value: ""
                    }
                }), {})
        })
    };

    render() {
        const {searchFieldsValues} = this.state;
        const {
            graphProps,
            searchFields,
            searchFieldsData,
            handleCleanAllClicked,
        } = this.props;

        return (
            <ParkingSlotGraph
                graphProps={graphProps}
                searchFields={searchFields}
                searchFieldsData={searchFieldsData}

                searchFieldsValues={searchFieldsValues}
                handleSearchFieldChange={this.handleSearchFieldChange}
                handleSearchSubmit={this.handleSearchSubmit}
                handleSearchClear={this.handleSearchClear}
                parking-page-table-info
                handleCleanAllClicked={handleCleanAllClicked}
                handleSearchFieldValueChanged={this.handleSearchFieldChange}
            />
        );
    }
}

export default ParkingSlotGraphContainer;